module.exports = __webpack_public_path__ + "static/media/ico-grow-light.54915681.svg";